import { createContext } from 'react';

const AuthContext = createContext({
  isLoaded: false, 
  setIsLoaded: () => {},
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  wt: null,
  setWT: () => {},
  // Add other auth-related state and functions (e.g., user data, login/logout)
});

export default AuthContext;
